import DropdownView from './views/DropdownView';
import MenuPanelView from './views/MenuPanelView';
import factory from './factory';

export default /** @lends module:core.dropdown */ {
    /**
     * DropdownView, PopoutView and panel/button views useful in common cases.
     * @namespace
     * */
    views: {
        DropdownView,
        MenuPanelView
    },
    factory
};
